import React, {useEffect, useMemo} from 'react';
import {useNavigate} from 'react-router-dom';

import {DefaultAppFooter} from 'src/components/default-footer.component';
import {useCurrentUser} from 'src/hooks/useCurrentUser';

import Typography from '@pb/kit-component-typography';


import {NavCardItem} from './components/nav-card-item';
import {WaveBackground} from './components/wave-background';
import {NAV_ITEMS} from './constants';

import {dashboard, dashboardFooter, dashboardTitle, navGrid} from './dashboard.module.styl';

export const Dashboard: React.FC = () => {
    const navigate = useNavigate();
    const {userTools} = useCurrentUser();

    const availableNavItems = useMemo(() => {
        const toolCodes = new Set(userTools.map(t => t.id));
        return NAV_ITEMS.filter(item => toolCodes.has(item.toolCode));
    }, [userTools]);

    useEffect(() => {
        if (availableNavItems.length === 1) {
            navigate(availableNavItems[0].path, {replace: true});
        }
    }, [availableNavItems, navigate]);

    if (availableNavItems.length === 1) {
        return null;
    }

    return (
        <>
            <WaveBackground/>
            <div className={dashboard}>
                <Typography variant="heading-level-1" className={dashboardTitle}>
                    Welcome to Client Portal
                </Typography>
                <div className={navGrid}>
                    {availableNavItems.map(({label, icon, path}) => (
                        <NavCardItem key={path} label={label} icon={icon} onClick={() => navigate(path)}/>
                    ))}
                </div>
                <div className={dashboardFooter}>
                    <DefaultAppFooter whiteTheme={true}/>
                </div>
            </div>
        </>
    );
};
